import Image from 'next/image'

import { Text } from '@percent/lemonade'
import styled from 'styled-components'
import HeartImage from '../../assets/images/heart.svg'
import { RecentDonationProps } from './recent-donation.types'

const StyledRecentDonationsListItem = styled.li`
  ${({ theme }) => `
      display: flex;
      flex-flow: row;
      justify-content: flex-start;
      align-items: top;
      flex-wrap: wrap;
      padding: 16px 0;
      border-bottom: 1px solid ${theme.colors.gray80};
      color: ${theme.colors.gray900};
      font-size: ${theme.fontSizes.body};
      font-weight: 400;
      gap: 8px;

      span:last-of-type {
        flex-grow: 1;
        text-align: right;
      }
    `}
`

const StyledRecentDonationsInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

const StyledRecentDonationsTextLine = styled.div`
  display: inline-flex;
  flex-flow: row;
  justify-content: flex-start;
  gap: 8px;
`

export function RecentDonation({
  donation,
  isAnonymous = false,
  totalAmount,
  donationTime,
  translations,
}: Readonly<RecentDonationProps>) {
  const displayName =
    isAnonymous || !donation.firstName
      ? translations.anonymous
      : donation.firstName
  const hasMatching = !!donation.matchedDonation

  return (
    <StyledRecentDonationsListItem key={donation.id}>
      <Image priority src={HeartImage} height={24} width={24} alt="Percent" />
      <StyledRecentDonationsInfo>
        <StyledRecentDonationsTextLine>
          <Text>{displayName}</Text>
          <Text>•</Text>
          <Text>{donationTime}</Text>
        </StyledRecentDonationsTextLine>
        {hasMatching &&
          translations.donationAmount &&
          translations.matchedAmount && (
            <StyledRecentDonationsTextLine>
              <Text size="small">{translations.donationAmount}</Text>
              <Text size="small">•</Text>
              <Text size="small">{translations.matchedAmount}</Text>
            </StyledRecentDonationsTextLine>
          )}
      </StyledRecentDonationsInfo>
      <Text fontWeight="medium">{totalAmount}</Text>
    </StyledRecentDonationsListItem>
  )
}
